import { WordPressService } from '@xq/infrastructure';

export class FetchWizardContentBodyUseCase {
  static async execute() {
    const wordPressService = WordPressService.getInstance();
    return wordPressService.fetchWizardContent();
  }
}
